/**
 * CORE-1791 — контурные иконки раздела сообщений из макета v3 (общий UI-набор
 * в приложенных HTML: сетка 24, линия 1.7, скруглённые концы). Это не набор
 * Live v3 и не системные emoji. Цвет — от вызывающего, размер глифа — 19 в
 * подложке 40, 22 в навигации (ТЗ).
 */
import React from 'react';
import { View } from 'react-native';
import Svg, { Circle, Path, Rect } from 'react-native-svg';

export type MessagesIconName =
  | 'sparkle' | 'people' | 'search' | 'more' | 'attach' | 'smile' | 'mic' | 'send' | 'chat' | 'back' | 'read' | 'sent' | 'alert';

interface Props {
  name: MessagesIconName;
  size: number;
  color: string;
  /** Линия выбранной навигации — 2 (макет), остальное — 1.7. */
  strokeWidth?: number;
  testID?: string;
}

export const MessagesIcon: React.FC<Props> = ({ name, size, color, strokeWidth = 1.7, testID }) => {
  const p = { stroke: color, strokeWidth, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, fill: 'none' };
  // Значок доставки 16×12, как в макете: квадратная сетка 24 вписана в рамку
  // (preserveAspectRatio по умолчанию), двойная галочка — «прочитано», одна —
  // «отправлено». Статус — из данных, не украшение.
  if (name === 'read' || name === 'sent') {
    const w = size;
    const h = Math.round((size * 12) / 16);
    return (
      <View testID={testID} style={{ width: w, height: h }} pointerEvents="none">
        <Svg width={w} height={h} viewBox="0 0 24 24">
          <Path d={name === 'read' ? 'm1 12 5 5L18 5m-6 12L24 5' : 'm4 12 5 5L21 5'} {...p} />
        </Svg>
      </View>
    );
  }
  let body: React.ReactNode;
  switch (name) {
    case 'sparkle': body = <Path d="m12 2 2.7 7.3L22 12l-7.3 2.7L12 22l-2.7-7.3L2 12l7.3-2.7Z" {...p} />; break;
    case 'people': body = <><Circle cx={9} cy={8} r={3} {...p} /><Path d="M2 21v-2a7 7 0 0 1 14 0v2M16 5a3 3 0 0 1 0 6m3 10v-2a7 7 0 0 0-2-5" {...p} /></>; break;
    case 'search': body = <><Circle cx={10.5} cy={10.5} r={6.5} {...p} /><Path d="m16 16 5 5" {...p} /></>; break;
    case 'more': body = <><Circle cx={4} cy={12} r={1} {...p} /><Circle cx={12} cy={12} r={1} {...p} /><Circle cx={20} cy={12} r={1} {...p} /></>; break;
    case 'attach': body = <Path d="m8 12 6-6a3 3 0 0 1 4 4l-8 8a5 5 0 0 1-7-7l9-9a7 7 0 0 1 10 10L12 22" {...p} />; break;
    case 'smile': body = <><Circle cx={12} cy={12} r={9} {...p} /><Path d="M8 14s1 3 4 3 4-3 4-3M8 8h.01M16 8h.01" {...p} /></>; break;
    case 'mic': body = <><Rect x={9} y={2} width={6} height={13} rx={3} {...p} /><Path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3m-4 0h8" {...p} /></>; break;
    case 'send': body = <Path d="m4 12 16-8-6 17-3-7-7-2Zm7 2 9-10" {...p} />; break;
    case 'chat': body = <><Path d="M21 11a9 9 0 0 1-9 9H3l1.5-5A9 9 0 1 1 21 11Z" {...p} /><Path d="M8 10h8M8 14h5" {...p} /></>; break;
    case 'back': body = <Path d="m14 5-7 7 7 7" {...p} />; break;
    // Ошибка (отправки, загрузки): контурный круг с восклицанием — форма, а не только цвет.
    case 'alert': body = <><Circle cx={12} cy={12} r={9} {...p} /><Path d="M12 7.5v5.5M12 16.5h.01" {...p} /></>; break;
    default: body = null;
  }
  return (
    <View testID={testID} style={{ width: size, height: size }} pointerEvents="none">
      <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">{body}</Svg>
    </View>
  );
};
